import { render, staticRenderFns } from "./ManuscriptHeader.vue?vue&type=template&id=175d94d2&scoped=true"
import script from "./ManuscriptHeader.vue?vue&type=script&lang=ts"
export * from "./ManuscriptHeader.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptHeader.vue?vue&type=style&index=0&id=175d94d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d94d2",
  null
  
)

export default component.exports